"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createService = createService;
Object.defineProperty(exports, "CognitoService", {
  enumerable: true,
  get: function get() {
    return _CognitoService2["default"];
  }
});
Object.defineProperty(exports, "TokensService", {
  enumerable: true,
  get: function get() {
    return _TokensService2["default"];
  }
});
Object.defineProperty(exports, "CoreService", {
  enumerable: true,
  get: function get() {
    return _CoreService2["default"];
  }
});
Object.defineProperty(exports, "configureMobile", {
  enumerable: true,
  get: function get() {
    return _configureMobile2["default"];
  }
});
Object.defineProperty(exports, "configure", {
  enumerable: true,
  get: function get() {
    return _configure2["default"];
  }
});
Object.defineProperty(exports, "configureWeb", {
  enumerable: true,
  get: function get() {
    return _configureWeb2["default"];
  }
});
Object.defineProperty(exports, "AxiosAdapter", {
  enumerable: true,
  get: function get() {
    return _AxiosAdapter2["default"];
  }
});
Object.defineProperty(exports, "BaseService", {
  enumerable: true,
  get: function get() {
    return _BaseService2["default"];
  }
});
Object.defineProperty(exports, "LocalConfigService", {
  enumerable: true,
  get: function get() {
    return _LocalConfigService2["default"];
  }
});
Object.defineProperty(exports, "LocalTokenStore", {
  enumerable: true,
  get: function get() {
    return _LocalTokenStore2["default"];
  }
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _AuthService = _interopRequireDefault(require("./AuthService"));

var _CognitoService2 = _interopRequireDefault(require("./CognitoService"));

var _TokensService2 = _interopRequireDefault(require("./TokensService"));

var _CoreService2 = _interopRequireDefault(require("./CoreService"));

var _configureMobile2 = _interopRequireDefault(require("./redux/configureMobile"));

var _configure2 = _interopRequireDefault(require("./configure"));

var _configureWeb2 = _interopRequireDefault(require("./redux/configureWeb"));

var _AxiosAdapter2 = _interopRequireDefault(require("./AxiosAdapter"));

var _BaseService2 = _interopRequireDefault(require("./BaseService"));

var _LocalConfigService2 = _interopRequireDefault(require("./LocalConfigService"));

var _LocalTokenStore2 = _interopRequireDefault(require("./LocalTokenStore"));

var services = {
  auth: _AuthService["default"],
  cognito: _CognitoService2["default"],
  tokens: _TokensService2["default"]
};

function createService() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    appVersion: null,
    appFeatures: null
  };
  var coreService = new _CoreService2["default"]();

  _lodash["default"].each(services, function (ServiceClass, name) {
    var service = new ServiceClass();
    service.AppVersion = options.appVersion;
    service.AppFeatures = options.appFeatures;
    coreService.register(name, service);
  });

  return coreService;
}

var DefaultCore = createService(); // Configuration Methods

var _default = DefaultCore;
exports["default"] = _default;